<template>
    <div class="customization">
        <div>
            <h4>Privacy Preferences</h4>
            <br />
            When you visit any website, it may collect and store information through cookies. These small data files help understand your preferences and improve your overall experience. While they usually don’t identify you directly, they make your web experience more personalized.<br />
            We value your privacy and are committed to being transparent about the types of cookies we use and how they enhance your experience. Explore the categories below to learn more and make choices about how your data is used, tailoring your web experience to your comfort level. Please note that rejecting some types of cookies may affect your experience on the marketplace and the services we can offer. For more information, please access our
            <a :href="privacyUrl" target="_blank">Privacy Policy</a>.
        </div>

        <div class="grid">
            <div class="label">
                <h4>Essential Cookies</h4>
                <small>
                    These cookies are crucial for the proper functioning of our website. They support vital features such as privacy settings, logging in, filling out forms (including those for uploading items to the marketplace), and enabling participation in our affiliate program, which allows you to invite friends and earn rewards. Without these cookies, some parts of the site may not work as intended.
                </small>
            </div>
            <input type="checkbox" checked disabled />
            <div class="label">
                <h4>Advertising Cookies</h4>
                <small>
                    These cookies are used by our advertising partners to build a profile of your interests and show you relevant ads on other websites. They do not store personal information directly but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will still see ads, but they will be less tailored to you.
                </small>
            </div>
            <input type="checkbox" value="analytics" v-model="customizedState" true-value="analytics" />
        </div>
        <div class="customization-buttons">
            <button class="btn btn-light" @click="rejectAll">Reject All</button>
            <button class="btn btn-green btn-lg" @click="saveCustomized">Confirm preferences</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "cookieManager",

    props: {
        cookies: {
            type: Array
        },
        privacyUrl: {}
    },

    data() {
        return {
            customizationOpen: false,
            customizedState: this.cookies && this.cookies.length ? this.cookies.slice() : [],
        }
    },

    methods: {
        setCookie(cookies) {
            if (cookies===false) {
                cookies = [];
            }
            document.cookie = "cookies_allowed=" + cookies.join(",") + ";max-age=" + 365*24*60*60 + ";";
        },

        saveCustomized() {
            this.setCookie(this.customizedState);
            window.location.reload();
        },

        rejectAll() {
            this.setCookie([]);
            window.location.reload();
        }
    }
}

</script>

<style scoped>
.customization {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    /* fix overlap with various widgets on the bottom-right on production*/
    padding-bottom: 10rem;
}
@media (min-width: 768px) {
    .customization {
        padding-bottom: 0;
    }
}
.grid {
    text-align: start;
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 1rem;
    align-items: center;
    width: 100%;
}
.grid .label {
    grid-column-start: 1;
    grid-column-end: 3;
}
.grid button {
    grid-column-start: 1;
    grid-column-end: 4;
    margin: 0 auto;
}
.grid input[type=checkbox] {
    width: 1.5rem;
    height: 1.5rem;
}
h4 {
    color: inherit;
    margin: 0;
    font-size: 0.9rem;
    font-weight: bold;
}
.customization-buttons {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    justify-content: end;
    align-items: center;
}
.btn-lg {
    font-size: 1.15rem;
}
</style>
